import { colors } from '../../colors';
var card = {
  textColorDark: colors.ash,
  textColorLight: colors.white,
  bgColor: colors.alabaster,
  bgColorHero: colors.alabaster
};
export default card;